import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({}, getTestId('StepCardWidgetContainer'));